import { render, staticRenderFns } from "./legal_translations_editor.vue?vue&type=template&id=7e144bf3&"
import script from "./legal_translations_editor.vue?vue&type=script&lang=js&"
export * from "./legal_translations_editor.vue?vue&type=script&lang=js&"
import style0 from "./legal_translations_editor.vue?vue&type=style&index=0&id=7e144bf3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports